function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosyncBricks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160pt",
    height: "160pt",
    viewBox: "0 0 160 160",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: -2.861,
    y: -2.409,
    width: 167.41,
    height: 167.84,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0, 0, 1, -3.021995157650524, -3.1908303561046054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.391 77.209 L 23.391 137.709 L 80.391 137.709 L 137.391 137.709 L 137.391 77.209 L 137.391 16.709 L 80.391 16.709 L 23.391 16.709 L 23.391 77.209 Z M 52.391 37.709 L 52.391 53.709 L 40.391 53.709 L 28.391 53.709 L 28.391 37.709 L 28.391 21.709 L 40.391 21.709 L 52.391 21.709 L 52.391 37.709 Z M 132.391 37.709 L 132.391 53.709 L 94.891 53.709 L 57.391 53.709 L 57.391 37.709 L 57.391 21.709 L 94.891 21.709 L 132.391 21.709 L 132.391 37.709 Z M 94.391 77.209 L 94.391 95.709 L 61.391 95.709 L 28.391 95.709 L 28.391 77.209 L 28.391 58.709 L 61.391 58.709 L 94.391 58.709 L 94.391 77.209 Z M 132.391 77.209 L 132.391 95.709 L 115.891 95.709 L 99.391 95.709 L 99.391 77.209 L 99.391 58.709 L 115.891 58.709 L 132.391 58.709 L 132.391 77.209 Z M 66.391 116.709 L 66.391 132.709 L 47.391 132.709 L 28.391 132.709 L 28.391 116.709 L 28.391 100.709 L 47.391 100.709 L 66.391 100.709 L 66.391 116.709 Z M 132.391 116.709 L 132.391 132.709 L 101.391 132.709 L 70.391 132.709 L 70.391 116.709 L 70.391 100.709 L 101.391 100.709 L 132.391 100.709 L 132.391 116.709 Z",
    style: {
      fill: "rgb(70, 56, 171)"
    },
    fill: "#000000",
    stroke: "none"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosyncBricks);
export default __webpack_public_path__ + "static/media/cosync_bricks.470c989588ec965b1704d36cc51acfae.svg";
export { ForwardRef as ReactComponent };